/**
 * Tách quy cách và màu của dòng vật tư.
 * Màu lấy từ spec_attributes.color, hoặc phần "Màu: ..." ghi cuối chuỗi quy cách (do Tạo PO từ BOM ghi).
 */
export function splitSpecColor(
  spec: string | null | undefined,
  attrs?: Record<string, unknown> | null,
): { spec: string; color: string } {
  const raw = (spec ?? '').trim()
  const colorValue = attrs?.color ?? attrs?.mau
  const attrColor = typeof colorValue === 'string' ? colorValue.trim() : ''
  const m = raw.match(/^(.*?)(?:\s*-\s*)?Màu:\s*(.+)$/i)
  return { spec: (m ? m[1] : raw).trim(), color: attrColor || (m ? m[2].trim() : '') }
}

/** A captured empty color stays empty even when the material master changes. */
export function poLineSpecColor(line: {
  spec?: string | null; spec_text?: string | null; spec_attributes?: Record<string, unknown> | null;
  price_snapshot?: { input: Record<string, unknown> } | null
}, materialAttrs?: Record<string, unknown> | null): { spec: string; color: string } {
  const captured = line.price_snapshot?.input
  if (captured) return splitSpecColor(String(captured.spec_text ?? captured.spec ?? line.spec_text ?? line.spec ?? ''), { ...((captured.spec_attributes as Record<string, unknown> | null) ?? line.spec_attributes), ...(captured.color != null ? { color: captured.color } : {}) })
  const saved = splitSpecColor(line.spec_text ?? line.spec, line.spec_attributes)
  return { spec: saved.spec || String(materialAttrs?.quy_cach ?? materialAttrs?.spec ?? '').trim(), color: saved.color || String(materialAttrs?.color ?? materialAttrs?.mau ?? '').trim() }
}

export function capturePoSpec(spec: unknown, attrs: Record<string, unknown>, materialAttrs?: Record<string, unknown> | null) {
  const merged: Record<string, unknown> = { ...materialAttrs, ...attrs, ...(attrs.mau && !attrs.color ? { color: attrs.mau } : {}) }
  const sc = splitSpecColor(String(spec || merged.quy_cach || merged.spec || ''), merged)
  return { spec: sc.spec, spec_attributes: { ...merged, ...(sc.color ? { color: sc.color } : {}) } }
}

export function receiptPoLineSpecColor(poLines: Array<Parameters<typeof poLineSpecColor>[0] & { id: string }>, poLineId: string | undefined, materialAttrs?: Record<string, unknown> | null) {
  return poLineSpecColor(poLines.find(line => line.id === poLineId) ?? {}, materialAttrs)
}
